import React, { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";

export default function Landing() {
  const nav = useNavigate();
  const [slug, setSlug] = useState("");

  const goToPortal = () => {
    const s = slug.trim();
    if (s) nav(`/r/${s}`);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        py: 6,
        bgcolor: "background.default",
      }}
    >
      <Stack alignItems="center" spacing={3} sx={{ maxWidth: 600 }}>
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: 3,
            bgcolor: "primary.main",
            color: "white",
            display: "grid",
            placeItems: "center",
          }}
        >
          <SwapHorizIcon sx={{ fontSize: 32 }} />
        </Box>

        <Typography variant="h4" textAlign="center">
          Salla Returns & Exchanges
        </Typography>

        <Typography variant="body1" color="text.secondary" textAlign="center" sx={{ maxWidth: 460 }}>
          A complete return management platform for Salla merchants. Automate returns,
          exchanges, and store credit from your Salla admin panel.
        </Typography>

        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ width: "100%", mt: 2 }}>
          <Card sx={{ flex: 1 }}>
            <CardContent>
              <Stack alignItems="center" spacing={1.5} sx={{ py: 1 }}>
                <StorefrontOutlinedIcon color="primary" sx={{ fontSize: 36 }} />
                <Typography variant="subtitle1">Merchants</Typography>
                <Typography variant="body2" color="text.secondary" textAlign="center">
                  Access your returns dashboard from the Salla Admin Panel under installed apps.
                </Typography>
                <Button
                  variant="outlined"
                  href="https://s.salla.sa/apps"
                  target="_blank"
                  rel="noopener"
                  size="small"
                >
                  Go to Salla Admin
                </Button>
              </Stack>
            </CardContent>
          </Card>

          <Card sx={{ flex: 1 }}>
            <CardContent>
              <Stack alignItems="center" spacing={1.5} sx={{ py: 1 }}>
                <PersonOutlineIcon color="primary" sx={{ fontSize: 36 }} />
                <Typography variant="subtitle1">Customers</Typography>
                <Typography variant="body2" color="text.secondary" textAlign="center">
                  Enter your store's return portal ID to start a return.
                </Typography>
                <TextField
                  label="Store Portal ID"
                  placeholder="e.g. my-store"
                  size="small"
                  fullWidth
                  value={slug}
                  onChange={(e) => setSlug(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && goToPortal()}
                />
                <Button
                  variant="outlined"
                  size="small"
                  disabled={!slug.trim()}
                  onClick={goToPortal}
                  endIcon={<ArrowForwardIcon />}
                >
                  Go to Portal
                </Button>
              </Stack>
            </CardContent>
          </Card>
        </Stack>

        <Typography variant="caption" color="text.secondary" sx={{ mt: 3 }}>
          Built for Salla &middot; Powered by Zoho Catalyst
        </Typography>
      </Stack>
    </Box>
  );
}
